var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  viewBox: "0 0 22 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 17.803V10h2v9.803H0V10h2v7.803z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 10.941 3.29-3.312 1.42 1.41-5.672 5.709-5.743-5.705 1.41-1.42L10 10.898V0h2z"
}))));
export default SvgDownloadDoc;